
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  
  function flitsCustomIntregation(){
    var lion_integrated_page_mobile = Flits(".flits-custom-lion-page-mobile").children();
    Flits(".flits-mobile-account-box .flits-navigation-header .flits-user-box").append(lion_integrated_page_mobile);
    Flits(".flits-custom-lion-page-mobile").remove();
  }
  
   // STORE CREDIT
if (Flits.customer_id != -1 && Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.isCustomerHasTagged) {
 Flits.LoadStyleScript('cartJs', window.flitsObjects.allCssJs.cartJs.url);
}
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    
    if(!window.isCustomerHasTagged){
    var valuesArr = event.detail.settings.navs,
        removeValFromIndex = [9,10,11,13,14];
    
    for (var i = removeValFromIndex.length -1; i >= 0; i--)
      valuesArr.splice(removeValFromIndex[i],1);
    }

  }); 

  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    setTimeout(function(){
     flitsCustomIntregation();
    },2500);
        
  });
  
  
  
  
  window.flitswishlistResponse = {};
Flits(document).on('Flits:Wishlist:AjaxSuccessful',function(event){
var data = event.detail;
window.flitswishlistResponse = data.resp;
});
Flits(document).on('Flits:getShopifyProductData:complete',function(event){
var data = event.detail;  
if(Flits(data.item).hasClass('flits-wishlist-card')){
if(!data.status){      
var itemDom = data.item;	
var product = flitsGetProductDetailsFromWishlistResponse(data.handle);
let image = "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
product.product_image != null && (image = product.product_image);
let extidx = image.lastIndexOf(".");
let extension = image.substr(extidx);
(image = image.replace(extension, "_200x_crop_center" + extension)), Flits(itemDom).find(".flits-product-image-thumbnail img").attr("src", image);
let imgWidth = Flits(itemDom).find(".flits-product-image img").width();
let imgHeight = Flits(itemDom).find(".flits-product-image img").height();
imgWidth > imgHeight;
Flits(itemDom).find(".flits-product-name").html(product.product_title );
Flits(itemDom).find(".flits-product-name").attr("data-tippy-content", product.product_title );
Flits(itemDom).find(".flits-product-price").html(Flits.formatMoney(Math.abs(0 * 100), Flits.money_format));
Flits(itemDom).find(".flits-product-price").css({
visibility:"hidden"
});
Flits(itemDom).find(".flits-select-row").css({
visibility:"hidden"
});              
Flits(itemDom).find(".flits-floating-label .flits-variant-select").hide();       
Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-id", product.product_id );
Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-title", product.product_title);
Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-handle", product.product_handle );
Flits(itemDom).find(".flits-add-to-cart").attr("data-remove", product.product_id);
let sold_out_text = Flits(itemDom).find(".flits-add-to-cart").attr("data-flits-sold-text");
Flits(itemDom).find(".flits-add-to-cart").addClass("flits-btn-danger");
Flits(itemDom).find(".flits-add-to-cart").attr("disabled", !0);
Flits(itemDom).find(".flits-add-to-cart").text(sold_out_text);
Flits(itemDom).find(".flits-product-quantity").addClass("flits-disabled");        
}
}
else if(Flits(data.item).find('.flits-product-card').hasClass('flits-recently-view-card')){    
if(!data.status){
Flits(data.item).css("display","none")
}
}
});
function flitsGetProductDetailsFromWishlistResponse(handle){
var item_details = undefined;
Flits.each(window.flitswishlistResponse.data,function(index,item){
if(item.product_handle == handle){
item_details = item;
return false;
}
});
return item_details;
}
  
}(Flits));
